import { Locale } from 'date-fns';
import format from 'date-fns/format';
import { zhTW, enUS } from 'date-fns/locale';
import pn from 'awesome-phonenumber';
import { Address } from '../types/common';

const localeMap: Record<string, Locale> = {
  en: enUS,
  'en-tw': enUS,
  'zh-tw': zhTW,
  'zh-hk': zhTW,
};

class Formatter {
  expires(date: Date, pattern = `d MMM yyyy H:mm`, locale = 'en') {
    return format(date, pattern, { locale: localeMap[locale] || enUS });
  }

  date(date: Date, pattern = `d MMM yyyy H:mm`, locale = 'en') {
    return format(date, pattern, { locale: localeMap[locale] || enUS });
  }

  phone(phoneNumber: string, dialCode: string) {
    const region = pn.getRegionCodeForCountryCode(parseInt(dialCode));
    return new pn(phoneNumber, region).getNumber();
  }

  address(address: Partial<Address>, country?: string) {
    const { street, city, postalCode, state } = address;

    if (country) {
      return [street, city, postalCode, state, country].filter(Boolean).join(', ');
    }

    return [street, city, postalCode, state].filter(Boolean).join(', ');
  }
}

export default new Formatter();
